import React from 'react';
import './Footer.css';
import { Link as LinkS } from 'react-scroll';
import Logo from '../../images/logo.png';
const Footer = () => {
    return (
        <div className='footer'>
            <div className='footer__content'>
                <div className='footer__left'>
                    <LinkS to='showcase' smooth={true} duration={1000}> <img src={Logo} alt='retbin' /></LinkS>
                    <p>retbin all rights reserved</p>
                </div>
                <div className='footer__right'>
                    <a href='https://twitter.com/Retbin1' target='_blank' className='footer__rightSocialMedia'>twitter</a>
                    <a href='https://www.instagram.com/retbin/' target='_blank' className='footer__rightSocialMedia'>instagram</a>
                    <a href='https://web.facebook.com/pg/Retbin-Inc-103078851760400/reviews/?ref=page_internal' target='_blank' className='footer__rightSocialMedia'>facebook</a>
                </div>
            </div>
        </div>
    )
}

export default Footer
